import React from 'react';
import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import { alpha, useTheme } from '@mui/material/styles';

import { bgGradient } from 'theme/css';

import Header from '../common/header-simple';
import {
  PrivacyPolicyLink,
  CookiePolicyLink,
  TermsAndConditionsLink,
} from 'components/iubenda/policy-links';

// ----------------------------------------------------------------------

export default function AuthBackgroundLayout({ children }) {
  const theme = useTheme();

  return (
    <>
      {/* <Header /> */}

      <Stack
        alignItems="center"
        sx={{
          ...bgGradient({
            color: alpha(theme.palette.background.default, 0.9),
            imgUrl: '/assets/background/overlay-1.jpg',
          }),
          minHeight: '100%',
          pt: 'var(--safe-area-top)',
          pb: 'var(--safe-area-bottom)',
          px: 2,
        }}
      >
        <Stack
          spacing={4}
          sx={{
            p: 4,
            width: 1,
            m: 'auto',
            flexShrink: 0,
            maxWidth: 400,
            borderRadius: 2,
            bgcolor: 'background.default',
            boxShadow: theme.customShadows.z24,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          {children}
        </Stack>

        <footer
          style={{
            width: '100%',
            textAlign: 'center',
            padding: '16px',
          }}
        >
          <Stack direction="row" spacing={4} justifyContent="center" alignItems="center">
            <PrivacyPolicyLink />
            <CookiePolicyLink />
            <TermsAndConditionsLink />
          </Stack>
        </footer>
      </Stack>
    </>
  );
}

AuthBackgroundLayout.propTypes = {
  children: PropTypes.node,
};
